import { motion } from 'framer-motion'
import { cn } from '@/lib/utils'
import { createPortal } from 'react-dom'
import { isNative } from '@/lib/platform'

interface ConsentModalProps {
  isOpen: boolean
  title: string
  content: string
  onClose: () => void
}

export function ConsentModal({ isOpen, title, content, onClose }: ConsentModalProps) {
  if (!isOpen || isNative()) return null

  return createPortal(
    <>
      {/* Backdrop */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        onClick={onClose}
        className="fixed inset-0 bg-black/50 z-[999]"
      />

      {/* Modal */}
      <motion.div
        initial={{ opacity: 0, scale: 0.95, y: 20 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        exit={{ opacity: 0, scale: 0.95, y: 20 }}
        transition={{ type: "spring", stiffness: 300, damping: 30 }}
        className="fixed inset-0 z-[1000] flex items-center justify-center p-4"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="bg-background rounded-[18px] shadow-xl max-w-2xl w-full max-h-[50vh] flex flex-col overflow-hidden p-8">
          {/* Title */}
          <h2 className="text-lg font-semibold text-foreground mb-6">{title}</h2>

          {/* Content */}
          <div className="flex-1 overflow-y-auto mb-6 p-4 rounded-lg border border-border bg-background">
            <div className="text-muted-foreground text-sm leading-relaxed whitespace-pre-wrap">
              {content}
            </div>
          </div>

          {/* Close Button */}
          <motion.button
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            onClick={onClose}
            className={cn(
              "w-full px-4 py-2 text-sm font-medium rounded-md transition-colors",
              "bg-primary text-primary-foreground hover:bg-primary/90"
            )}
            type="button"
          >
            Close
          </motion.button>
        </div>
      </motion.div>
    </>,
    document.body
  )
}
